import { QueryFeature } from '../../../config/queryClient';
import { PerformancePeriodDTO, TabSlug } from '../types';

// TODO: Add to this factory for other queries in folder with OPL migration: https://dev.azure.com/orionadvisor/Orion%20Agile/_workitems/edit/127739

enum QueryKey {
  Transfers = 'Transfers',
  ScheduledTransfers = 'ScheduledTransfers',
  Transactions = 'Transactions',
  GroupedTransactions = 'GroupedTransactions',
  RmdDashboard = 'RmdDashboard',
  Widgets = 'Widgets',
  ProjectedIncome = 'ProjectedIncome',
  IncomeDetails = 'IncomeDetails',
}

export const queryKeys = {
  transfers: ({ clientId, managedAccountId }: { clientId: string; managedAccountId: string }) => [
    QueryFeature.AccountPerformanceReporting,
    QueryKey.Transfers,
    clientId,
    managedAccountId,
  ],

  scheduledTransfers: ({
    clientId,
    managedAccountId,
  }: {
    clientId: string;
    managedAccountId: string;
  }) => [
    QueryFeature.AccountPerformanceReporting,
    QueryKey.ScheduledTransfers,
    clientId,
    managedAccountId,
  ],

  transactions: (filters?: {
    clientId: string;
    accountId?: string;
    groupId?: string;
    period?: number;
    startDate?: string;
    endDate?: string;
    sortBy: string;
    sortDesc: boolean;
    query?: string;
  }) => [
    QueryFeature.AccountPerformanceReporting,
    QueryKey.Transactions,
    ...(filters
      ? [
          filters.clientId,
          filters.accountId,
          filters.groupId,
          filters.period,
          filters.startDate,
          filters.endDate,
          filters.sortBy,
          filters.sortDesc,
          filters.query,
        ]
      : []),
  ],

  groupedTransactions: (filters?: {
    clientId: string;
    accountId?: string;
    groupId?: string;
    period?: number;
    startDate?: string;
    endDate?: string;
  }) => [
    QueryFeature.AccountPerformanceReporting,
    QueryKey.GroupedTransactions,
    ...(filters
      ? [
          filters.clientId,
          filters.accountId,
          filters.groupId,
          filters.period,
          filters.startDate,
          filters.endDate,
        ]
      : []),
  ],

  rmdDashboard: (clientId: string, accountId: string, groupId: string) => [
    QueryFeature.AccountPerformanceReporting,
    QueryKey.RmdDashboard,
    clientId,
    accountId,
    groupId,
  ],

  widgets: (clientId: number, tab: TabSlug) => [
    QueryFeature.AccountPerformanceReporting,
    QueryKey.Widgets,
    clientId,
    tab,
  ],

  projectedIncome: (
    clientId: number,
    period?: PerformancePeriodDTO,
    startDate?: string,
    endDate?: string,
    accountId?: string,
    groupId?: string,
  ) => [
    QueryFeature.AccountPerformanceReporting,
    QueryKey.ProjectedIncome,
    clientId,
    period,
    startDate,
    endDate,
    accountId,
    groupId,
  ],

  incomeDetails: (
    clientId: number,
    period?: PerformancePeriodDTO,
    startDate?: string,
    endDate?: string,
    accountId?: string,
    groupId?: string,
  ) => [
    QueryFeature.AccountPerformanceReporting,
    QueryKey.IncomeDetails,
    clientId,
    period,
    startDate,
    endDate,
    accountId,
    groupId,
  ],
};
